






import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Gallery from "@/components/Gallery.vue";

@Component({
  name: "Home",
  components: {
    Gallery
  }
})
export default class Home extends Vue {
  // eslint-disable-next-line
  @Prop() private assets!: any;
}
